import {
  Breadcrumb,
  Button,
  Card,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import successIcon from "../../assests/images/success.png";
import { NumericFormat } from "react-number-format";
import CommonOtp from "../../components/otp";
import SendMoneyService from "../../services/send-money.service";
import { useEffect } from "react";
import {
  accountListSelector,
  modeSelector,
  profileDetailsSelector,
  selectedAccountSelector,
} from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import TransferService from "../../services/transfer.service";
import {
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  allowOnlyAlphabetsShouldNotStartWithSpace,
  allowOnlyAlphaNumerics,
  allowOnlyAlphabets,
  allowOnlyAlphabetsWithSpace,
  allowOnlyNumbers,
  amountFormat,
  handlePasteNotAllowSpace,
} from "../../services/common.service";
import { CONFIG } from "../../environment";
import checkedIcon from "../../assests/images/checked.svg";
import unCheckedIcon from "../../assests/icons/uncheck.png";
import AccountCard from "../../components/account-card";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { ReactComponent as TitleIcon } from "../../assests/images/transfer.svg";
import OTP from "../../components/otp";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function AddPesaLinkPayee(props) {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [formDetails, setFormDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [verifyDetails, setVerifyDetails] = useState({});
  const [message, setMessage] = useState("");
  const [form] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState({});
  const [bankDetails, setBankDetails] = useState([]);
  // const [selectedOption, setSelectedOption] = useState(null);
  const [selectedBank, setSelectedBank] = useState("");
  const mode = useSelector(modeSelector);
  const [autoAuth, setAutoAuth] = useState(false);
  const [selectedBeneType, setSelectedBeneType] = useState("PESALINK");
  const [selectedModeOfBeneficiary, setSelectedModeOfBeneficiary] =
    useState("BANK");
  const [fspFilteredList, setFspFilteredCodesList] = useState([]);
  const [selectedFspBank, setSelectedFspBank] = useState({});
  const [isGroupVisibility, setISGroupVisibilty] = useState(false);
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [cancelVisible, setCancelVisible] = useState(false);
  const profileDetails = useSelector(profileDetailsSelector);
  const { t } = useTranslation();
  const accountList = useSelector(accountListSelector);
  const selectedAccount = useSelector(selectedAccountSelector);
  const location = useLocation();

  useEffect(() => {
    form.setFieldsValue({
      beneType: "PESALINK",
    });
    if (location.state && location.state.mode) {
      setSelectedBeneType(location.state.mode);
      form.setFieldsValue({
        beneType: location.state.mode,
      });
    }
  }, []);

  useEffect(() => {
    if (selectedBeneType !== "EAPS" || selectedBeneType !== "REPSS") {
      getBankDetails();
    }
  }, [selectedBeneType]);

  useEffect(() => {
    if (selectedBank) {
      getBranchDetails(selectedBank);
    }
  }, [selectedBank]);

  const getBankDetails = useCallback(async () => {
    try {
      const response = await SendMoneyService.getBankDetails();
      if (response.status === 200) {
        setBankList(response.data);
      }
    } catch (error) {}
  }, []);

  const getEAPBankList = useCallback(async (e) => {
    try {
      setBankDetails([]);
      if (e.target.value.length > 8) {
        const reqParams = {
          countryCode: e.target.value,
        };
        const response = await TransferService.swiftCodeLookUp(reqParams);
        if (response.status === 200) {
          setFspFilteredCodesList(
            response?.data["swiftLookUpDeatilsResponse"][0]
          );
          form.setFieldsValue({
            bankName: response?.data["swiftLookUpDeatilsResponse"][0].bankName,
          });
        }
      }
    } catch (error) {}
  }, []);

  const getBranchDetails = useCallback(async (bankName) => {
    try {
      setFspFilteredCodesList([]);
      const response = await SendMoneyService.getBranchDetails({
        bankName: bankName,
        page: 0,
        size: 100,
      });
      if (response.status === 200) {
        setBankDetails(response.data["data"][0]);
      }
    } catch (error) {}
  }, []);

  const accountLookUp = useCallback(
    async (accountNo) => {
      try {
        form.setFieldsValue({
          beneName: "",
        });
        setAccountDetails({});
        if (
          +accountNo.length >= CONFIG?.ACCOUNT_NO_MIN_LENGTH &&
          +accountNo.length <= CONFIG?.OTHER_ACCOUNT_NO_LENGTH
        ) {
          const response = await SendMoneyService.accountLookUp({
            transferType: selectedBeneType,
            accountNo: accountNo,
            bankName:
              selectedBeneType !== "EAPS" && selectedBeneType !== "REPSS"
                ? bankDetails?.bankName
                : fspFilteredList.bankName,
            mobileNo: "",
            custParams: {
              IDENTIFIER: "BANK",
              FSPCODE:
                selectedBeneType !== "EAPS" && selectedBeneType !== "REPSS"
                  ? bankDetails?.bicCode
                  : fspFilteredList.swiftCode,
            },
          });
          if (response.status === 200) {
            setAccountDetails(response.data);
            form.setFieldsValue({
              beneName: response.data?.customerName || undefined,
              txnCcy: response.data.accCcy,
            });
          }
        }
      } catch (error) {
        setAccountDetails({});
      }
    },
    [selectedBeneType, selectedModeOfBeneficiary, bankDetails, fspFilteredList]
  );

  const onVerify = useCallback(
    async (values) => {
      try {
        setLoader(true);
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );
        const requestParams = {
          favorites: "N",
          beneAccNo: values?.beneAccNo || "",
          beneNickName: values?.beneNickName,
          beneName: accountDetails?.customerName || values?.beneName,
          maxTransferLimit:
            values?.maxTransferLimit !== undefined
              ? parseInt(
                  values?.maxTransferLimit.toString().replaceAll(/,/g, "")
                )
              : "",
          beneType: selectedBeneType,
          bankName: bankDetails?.bankName || fspFilteredList.bankName,
          beneBrn: bankDetails?.branchCode || CONFIG?.BRANCH_NAME,
          bicCode: bankDetails?.bicCode || fspFilteredList.swiftCode,
          sortCode: bankDetails?.sortCode || "",
          beneCurrency: accountDetails?.accCcy || CONFIG.CURRENCY,
          otp: "",
          authType: "A",
          beneMobileNo: "",
          beneEmail: values?.beneEmail || "",
          beneAddress: values?.beneAddrOne,
          customFields: {
            DISPLAY: null,
            payeeAccCategory: "BUSINESS",
            payeeAccType: selectedFspBank?.fspType,
            payeeIdnfrType: selectedFspBank?.fspType,
            payerAccCategory: "BUSINESS",
            payerAccType: selectedFspBank?.fspType,
            payerIdnfrType: selectedFspBank?.fspType,
            payerName: srcAccDetails?.accountName,
            beneAddrOne: values?.beneAddrOne,
            beneAddrTwo: values?.beneAddrOne,
            IDENTIFIER: selectedFspBank?.fspType,
            FSPCODE: bankDetails?.bicCode || fspFilteredList.swiftCode,
          },
          visibleToGroup:
            profileDetails["retail"] !== true ? isGroupVisibility : true,
        };
        setFormDetails({ ...requestParams });
        const response = await SendMoneyService.addPayeeVerify(requestParams);
        if (response.status === 200) {
          setLoader(false);
          setVerifyDetails(response.data);
          setStage(2);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [accountDetails, bankDetails, isGroupVisibility, selectedBeneType]
  );

  const handleResendOtp = useCallback(
    async (values) => {
      try {
        const requestParams = {
          ...formDetails,
        };
        const response = await SendMoneyService.addPayeeVerify(requestParams);
        if (response.status === 200) {
          setLoader(false);
        }
      } catch (error) {}
    },
    [formDetails]
  );

  const onConfirm = useCallback(async (values) => {
    try {
      setLoader(true);
      const response = await SendMoneyService.addPayeeConfirm({
        ...values,
      });
      if (response.status === 200) {
        setLoader(false);
        setMessage(response.data["message"]);
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
    }
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            onConfirm={(values) => onConfirm({ ...formDetails, ...values })}
            handleResendOtp={() => handleResendOtp(formDetails)}
            cancelTransaction={() => {
              navigate("/pesaLink");
            }}
            type="ADD_PAYEE"
          />
        );
      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row">
          <p className="mb-3">
            {t("common.proceed_fill_txt", {
              defaultValue: "Please fill required details, before you proceed",
            })}
          </p>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <Form
              layout="vertical"
              initialValues={formDetails}
              onFinish={onVerify}
              form={form}
            >
              <div className="row">
                {selectedBeneType === "PESALINK" && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <Form.Item
                      name={"bankName"}
                      label={t("pages.standing_instruction.beneficiary_bank", {
                        defaultValue: "Beneficiary Bank",
                      })}
                      rules={[
                        {
                          required: true,
                          message: t(
                            "pages.standing_instruction.beneficiary_bank_req_txt",
                            {
                              defaultValue: "Beneficiary Bank is required",
                            }
                          ),
                        },
                      ]}
                    >
                      <Select
                        placeholder={t(
                          "pages.standing_instruction.beneficiary_bank",
                          {
                            defaultValue: "Beneficiary Bank",
                          }
                        )}
                        bordered={true}
                        optionFilterProp="children"
                        showSearch
                        size="large"
                        onChange={(value) => {
                          getBranchDetails(value);
                          form.setFieldsValue({
                            beneAccNo: "",
                            beneName: "",
                          });
                        }}
                      >
                        {bankList.map((option, idx) => (
                          <Select.Option key={idx} value={option}>
                            {option}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                {(selectedBeneType === "EAPS" ||
                  selectedBeneType === "REPSS") && (
                  <>
                    <div className="col-12">
                      <Form.Item
                        name="bicCode"
                        label={t("pages.Add_Bene.bic_code", {
                          defaultValue: "Bic Code",
                        })}
                        rules={[
                          {
                            required: true,
                            message: t("pages.Add_Bene.bic_code_required", {
                              defaultValue: "Bic Code is required",
                            }),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pages.Add_Bene.bic_code", {
                            defaultValue: "Bic Code",
                          })}
                          size="large"
                          onBlur={getEAPBankList}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-12">
                      <Form.Item
                        name="bankName"
                        label={t("pages.sendMoney.payee.bank_name", {
                          defaultValue: "Bank Name",
                        })}
                        rules={[
                          {
                            required: false,
                            message: t("pages.Add_Bene.bank_name_req", {
                              defaultValue: "Bank Name is required",
                            }),
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pages.sendMoney.payee.bank_name", {
                            defaultValue: "Bank Name",
                          })}
                          size="large"
                          readOnly
                        />
                      </Form.Item>
                    </div>
                  </>
                )}

                {selectedBeneType === "PESALINK" && (
                  <div className="col-12">
                    <Form.Item
                      name="beneAddrOne"
                      label={t(
                        "pages.standing_instruction.beneficiary_address",
                        {
                          defaultValue: "Beneficiary Address",
                        }
                      )}
                      rules={[
                        {
                          required: true,
                          message: t(
                            "pages.standing_instruction.beneficiary_address_req_txt",
                            {
                              defaultValue: "Beneficiary Address is required",
                            }
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={t(
                          "pages.standing_instruction.beneficiary_address",
                          {
                            defaultValue: "Beneficiary Address",
                          }
                        )}
                        size="large"
                      />
                    </Form.Item>
                  </div>
                )}

                {selectedBeneType === "PESALINK" ? (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <Form.Item
                      name="beneAccNo"
                      label={t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                      rules={[
                        {
                          required: true,
                          message: t("errorMesssages.account_no_requir", {
                            defaultValue: "Account Number is required",
                          }),
                        },
                        {
                          min: CONFIG?.ACCOUNT_NO_MIN_LENGTH,
                          max: 23,
                          message:
                            t("pages.standing_instruction.bene_acc_no_should", {
                              defaultValue:
                                "Beneficiary Account Number should be min ",
                            }) +
                            " " +
                            CONFIG?.ACCOUNT_NO_MIN_LENGTH +
                            " " +
                            t("pages.standing_instruction.and_max", {
                              defaultValue: "and max",
                            }) +
                            " " +
                            "23",
                        },
                      ]}
                    >
                      <Input
                        maxLength={23}
                        placeholder={t("common.account_no_lbl", {
                          defaultValue: "Account Number",
                        })}
                        size="large"
                        onKeyPress={(e) => allowOnlyNumbers(e)}
                        onPaste={(e) => handlePasteNotAllowSpace(e)}
                        onBlur={(e) => {
                          if (form.getFieldValue("bankName"))
                            accountLookUp(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </div>
                ) : (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <Form.Item
                      name="beneAccNo"
                      label={t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                      rules={[
                        {
                          required: true,
                          message: t("errorMesssages.account_no_requir", {
                            defaultValue: "Account Number is required",
                          }),
                        },
                        {
                          min: CONFIG?.ACCOUNT_NO_MIN_LENGTH,
                          max: CONFIG?.ACCOUNT_NUMBER_MAX_LENGTH,
                          message:
                            t("pages.standing_instruction.bene_acc_no_should", {
                              defaultValue:
                                "Beneficiary Account Number should be min ",
                            }) +
                            " " +
                            CONFIG?.ACCOUNT_NO_MIN_LENGTH +
                            " " +
                            t("pages.standing_instruction.and_max", {
                              defaultValue: "and max",
                            }) +
                            " " +
                            CONFIG?.ACCOUNT_NUMBER_MAX_LENGTH,
                        },
                      ]}
                    >
                      <Input
                        maxLength={CONFIG?.ACCOUNT_NUMBER_MAX_LENGTH}
                        placeholder={t("common.account_no_lbl", {
                          defaultValue: "Account Number",
                        })}
                        size="large"
                        onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                        onPaste={(e) => handlePasteNotAllowSpace(e)}
                        onBlur={(e) => {
                          if (form.getFieldValue("bankName"))
                            accountLookUp(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </div>
                )}

                <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                  <Form.Item
                    name="beneName"
                    label={t("pages.Add_Bene.bane_name", {
                      defaultValue: "Beneficiary Name",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("pages.Add_Bene.bene_name_req", {
                          defaultValue: "Beneficiary Name is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      maxLength={30}
                      placeholder={t("pages.Add_Bene.bane_name", {
                        defaultValue: "Beneficiary Name",
                      })}
                      size="large"
                      onKeyPress={(e) => allowOnlyAlphabetsShouldNotStartWithSpace(e)}
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                  <Form.Item
                    name="beneNickName"
                    label={t("pages.Add_Bene.bene_nick_name", {
                      defaultValue: "Beneficiary Nick Name",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("pages.Add_Bene.bene_nick_name_req", {
                          defaultValue: "Beneficiary Nick Name is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      maxLength={30}
                      onKeyPress={(e) => allowOnlyAlphabetsShouldNotStartWithSpace(e)}
                      placeholder={t("pages.Add_Bene.bene_nick_name", {
                        defaultValue: "Beneficiary Nick Name",
                      })}
                      size="large"
                    />
                  </Form.Item>
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <Form.Item
                    name="maxTransferLimit"
                    label={t("pages.transfer_limit.transfer_limit", {
                      defaultValue: "Transfer Limit",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("pages.Add_Bene.transfer_limit_req", {
                          defaultValue: "Transfer Limit is required",
                        }),
                      },
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (
                            !value ||
                            getFieldValue("maxTransferLimit").replaceAll(
                              /,/g,
                              ""
                            ) > 0
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            t("pages.Add_Bene.transfer_limit_valid", {
                              defaultValue:
                                "Transfer Limit should be greater than 0",
                            })
                          );
                        },
                      }),
                    ]}
                  >
                    <NumericFormat
                      type="tel"
                      size="large"
                      maxLength={12}
                      placeholder={t("pages.transfer_limit.transfer_limit", {
                        defaultValue: "Transfer Limit",
                      })}
                      allowNegative={false}
                      customInput={Input}
                      thousandSeparator={true}
                      fixedDecimalScale={false}
                      onKeyPress={(e) => allowOnlyNumbers(e)}
                    />
                  </Form.Item>
                </div>
              </div>
              <div>
                {profileDetails["retail"] !== true && (
                  <>
                    <div>
                      <span
                        style={{ marginRight: "5px ", cursor: "pointer" }}
                        onClick={() => {
                          setISGroupVisibilty(!isGroupVisibility);
                        }}
                      >
                        {isGroupVisibility ? (
                          <img
                            src={checkedIcon}
                            alt="checked"
                            width={17}
                            height={17}
                            className="checked"
                          />
                        ) : (
                          <img
                            src={unCheckedIcon}
                            alt="unchecked"
                            width={17}
                            height={17}
                            className="unchecked"
                          />
                        )}{" "}
                        {t("pages.Add_Bene.visible_to_group", {
                          defaultValue: "Visible To Group",
                        })}
                      </span>
                    </div>
                  </>
                )}
              </div>

              <div className="d-flex align-items-center justify-content-end mt-3">
                <Button
                  type="default"
                  onClick={() => navigate("/pesaLink")}
                  size="large"
                  className="secondary-btn mx-3"
                >
                  {t("buttons.cancel_btn", {
                    defaultValue: "Cancel",
                  })}
                </Button>

                <Button
                  htmlType="submit"
                  type="primary"
                  // loading={loader}
                  size="large"
                  className="text-light"
                  disabled={Object.keys(accountDetails).length == 0}
                >
                  {t("buttons.submit_btn", {
                    defaultValue: "Submit",
                  })}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3 bold-text">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.Add_Bene.please_check_bene_details", {
            defaultValue:
              "Please check the beneficiary details carefully, before you proceed",
          })}
        </p>
        <div className="confirm-details">
          <div className="row">
            {/* <div className="confirm-label-wrapper">
              <label>
                {t("pages.pending_approval.transfer_type", {
                  defaultValue: "Transfer Type",
                })}
              </label>
              <span>{selectedBeneType}</span>
            </div> */}
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}
              </label>
              <span>{formDetails?.beneName || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bene_nick_name", {
                  defaultValue: "Beneficiary Nick Name",
                })}
              </label>
              <span>{formDetails?.beneNickName}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
              </label>
              <span>{formDetails?.beneAccNo}</span>
            </div>

            {/* {formDetails.bicCode && (
                <div className="confirm-label-wrapper">
                  <label>{t("pages.Add_Bene.bic_code", {
                            defaultValue: "Bic Code",
                          })}</label>
                  <span>{formDetails?.bicCode || "-"}</span>
                </div>
              )} */}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.payee.bank_name", {
                  defaultValue: "Bank Name",
                })}
              </label>
              <span>{formDetails?.bankName || "-"}</span>
            </div>

            {/* {selectedBeneType === "OTHERBANK" && (
                <>
                  <div className="confirm-label-wrapper">
                    <label>{t("pages.sendMoney.payee.branch_name", {
              defaultValue: "Branch Name",
            })}</label>
                    <span>{formDetails?.beneBrn}</span>
                  </div>
                </>
              )} */}

            {formDetails?.beneAddress && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.standing_instruction.beneficiary_address", {
                    defaultValue: "Beneficiary Address",
                  })}
                </label>
                <span>{formDetails?.beneAddress}</span>
              </div>
            )}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.transfer_limit.transfer_limit", {
                  defaultValue: "Transfer Limit",
                })}
              </label>

              <span>
                {formDetails?.maxTransferLimit
                  ? amountFormat(
                      formDetails?.maxTransferLimit,
                      formDetails?.beneCurrency
                    )
                  : "-"}
              </span>
            </div>

            {profileDetails["retail"] !== true && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.Add_Bene.visible_to_group", {
                    defaultValue: "Visible To Group",
                  })}
                </label>
                <span>
                  {formDetails?.visibleToGroup === true
                    ? t("common.yes", { defaultValue: "Yes" })
                    : t("common.no", { defaultValue: "No" })}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-4">
          {/* <Button
              type="default"
              onClick={() => setCancelVisible(true)}
              size="large"
              className="secondary-btn mx-3"
            >
              Cancel
            </Button> */}
          <Button
            onClick={() => setStage(1)}
            type="default"
            className="secondary-btn mx-3"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            onClick={() =>
              verifyDetails["otpEnabled"]
                ? setStage(3)
                : onConfirm({
                    ...formDetails,
                    ...{ otp: CONFIG.DEFAULT_OTP },
                  })
            }
            size="large"
          >
            {" "}
            {t("buttons.confirm", { defaultValue: "Confirm" })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      {" "}
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/pesaLink")}>  {t("navigation.pesaLink", {
                  defaultValue: "Pesalink",
                })}</span>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <span>Add Pesalink Beneficiary</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center">
        <div className="row">
          <div
            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0"
            style={{ margin: "-6px 0px" }}
          >
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <div className="d-flex" style={{ height: "25px" }}>
              <p className="title title-header hide-xs">
                Add Pesalink Beneficiary
              </p>
            </div>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card render-form-container">
            {renderSwitch()}
          </Card>
        </div>
      </div>
      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/pesaLink");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        title={t("common.cancal", {
          defaultValue: "Cancel ?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("common.commont_otp_desc", {
            defaultValue:
              "If you cancel this now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            className="secondary-btn"
            type="default"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/pesaLink");
            }}
          >
            {t("common.yes", { defaultValue: "Yes" })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
